import { render, staticRenderFns } from "./AmazoniaProtege.vue?vue&type=template&id=cdabf4e2&lang=pug"
import script from "./AmazoniaProtege.vue?vue&type=script&lang=js"
export * from "./AmazoniaProtege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports